import { Response } from '@marketplace-web/core-api/api-client-util'

import { UserThumbnailSize } from '@marketplace-web/shared/utils'

import { transformLabelFormatDetails } from './label-format-details'
import { transformDropOffType } from './drop-off'
import { transformReturnShippingOptionDto } from './return-shipment'
import { transformCarrierDto } from './carrier'
import { transformCurrencyAmountDto } from './currency-amount'
import {
  ShipmentInstructionsDto,
  ShipmentInstructions,
  ShipmentInstructionsResponse,
} from '../types/shipment-instructions'

const transformUserPhotoDto = (photoDto: {
  url: string
  thumbnails: Array<{
    type: UserThumbnailSize
    url: string
  }>
}) => ({
  url: photoDto.url,
  thumbnails: photoDto.thumbnails,
})

export const transformShipmentInstructions = (
  response: ShipmentInstructionsDto,
): ShipmentInstructions => ({
  carrier: transformCarrierDto(response.carrier),
  carrierCode: response.carrier_code,
  hint: response.hint,
  id: response.id,
  instructions: response.instructions,
  currency: response.currency,
  price: response.price,
  priceTitle: response.price_title,
  receiverAddress: response.receiver_address,
  receiverFullAddress: response.receiver_full_address,
  receiverName: response.receiver_name,
  receiverTitle: response.receiver_title,
  receiverPhoto: response.receiver_photo && transformUserPhotoDto(response.receiver_photo),
  dropOffType: response.drop_off_type && transformDropOffType(response.drop_off_type),
  labelFormatDetails:
    response.label_format_details && transformLabelFormatDetails(response.label_format_details),
  returnShippingOption:
    response.return_shipping_option &&
    transformReturnShippingOptionDto(response.return_shipping_option),
  actionTitle: response.action_title,
  screenTitle: response.screen_title,
  shippingPrice: transformCurrencyAmountDto(response.shipping_price),
  dropOffMapEnabled: response.drop_off_map_enabled,
  carrierTermsAndConditions: response.carrier_terms_and_conditions
    ? response.carrier_terms_and_conditions
    : null,
})

export const transformShipmentInstructionsResponse = (
  response: Response<ShipmentInstructionsResponse>,
) => transformShipmentInstructions(response.shipment_instructions)
